import { Inference, InferenceStatus, ShowoffTags } from 'type/Inference'
import { parseJson } from 'util/json'

export type InferenceEventImageRaw = {
  int_id: number
  url: string
  isVideo?: 0 | 1
  showoff_tags?: string
}

export type InferenceEventImage = {
  int_id: number
  url: string
  isVideo?: 0 | 1
  showoff_tags?: ShowoffTags
}

export type InferenceEvent = {
  inference_id: string
  status: InferenceStatus
  images: InferenceEventImage[]
}

export type InferenceListener = (event: InferenceEvent) => void
export type InferenceFallback = (json: Inference) => void

export function extractImage(raw: InferenceEventImageRaw): InferenceEventImage {
  const {
    int_id,
    isVideo,
    url,
  } = raw
  const showoff_tags = parseJson<ShowoffTags>(raw.showoff_tags)

  if (showoff_tags) {
    const custom = showoff_tags.data?.custom_collection_data
    if (custom) custom.description = custom.description?.replaceAll('/n', '\n')
    const items = showoff_tags.data?.items
    if (items) {
      for (const item of items) {
        item.description = item.description?.replaceAll('/n', '\n')
      }
    }
  }

  return {
    int_id,
    isVideo,
    showoff_tags,
    url,
  }
}
